/*============================================================================
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  Plugin Documentation - https://shopify.github.io/Timber/#ajax-cart

  Ajaxify the add to cart experience and flip the button for inline confirmation,
  show the cart in a modal, or a 3D drawer.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajaxify plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  JQUERY API (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
  Includes slight modifications to addItemFromForm.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
}

/*============================================================================
  API Functions
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ( !Shopify.formatMoney ) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

Shopify.onProduct = function(product) {
  // alert('Received everything we ever wanted to know about ' + product.title);
};

Shopify.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

Shopify.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  } else {
    alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the line item associated with the added item
==============================================================================*/
Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  POST to cart/add.js returns the JSON of the line item
    - Allow use of form element instead of id
    - Allow custom error callback
==============================================================================*/
Shopify.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        Shopify.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
Shopify.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      Shopify.onCartUpdate(cart);
    }
  });
};

// GET products/<product-handle>.js returns the product in JSON
Shopify.getProduct = function(handle, callback) {
  jQuery.getJSON('/products/' + handle + '.js', function (product, textStatus) {
    if ((typeof callback) === 'function') {
      callback(product);
    }
    else {
      Shopify.onProduct(product);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
Shopify.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajaxify Shopify Add To Cart
==============================================================================*/
var ajaxifyShopify = (function(module, $) {

  'use strict';

  // Public functions
  var init;

  // Private general variables
  var settings, isUpdating, cartInit, $drawerHeight, $cssTransforms, $cssTransforms3d, $nojQueryLoad, $w, $body, $html;

  // Private plugin variables
  var $formContainer, $btnClass, $wrapperClass, $addToCart, $flipClose, $flipCart, $flipContainer, $cartCountSelector, $cartCostSelector, $toggleCartButton, $modal, $cartContainer, $drawerCaret, $drawerOverlay, $modalContainer, $modalOverlay, $closeCart, $drawerContainer, $prependDrawerTo, $callbackData={};

  // Private functions
  var updateCountPrice, getDisplayItemCount, getBundleId, isBundleParent, buildDrawerRows, flipSetup, revertFlipButton, modalSetup, showModal, sizeModal, hideModal, drawerSetup, showDrawer, hideDrawer, sizeDrawer, loadCartImages, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, setToggleButtons, flipCartUpdateCallback, buildCart, cartTemplate, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, scrollTop, toggleCallback, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      method: 'drawer', // Method options are drawer, modal, and flip. Default is drawer.
      formSelector: 'form[action^="/cart/add"]',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      toggleCartButton: null,
      btnClass: null,
      wrapperClass: null,
      useCartTemplate: false,
      moneyFormat: '${{amount}}',
      disableAjaxCart: false,
      enableQtySelectors: true,
      prependDrawerTo: 'body',
      onToggleCallback: null
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Make sure method is lower case
    settings.method = settings.method.toLowerCase();

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $btnClass          = settings.btnClass;
    $wrapperClass      = settings.wrapperClass;
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $flipContainer     = null;
    $flipClose         = null;
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $toggleCartButton  = $(settings.toggleCartButton);
    $modal             = null;
    $prependDrawerTo   = $(settings.prependDrawerTo);

    // CSS Checks
    $cssTransforms   = (window.Modernizr && Modernizr.csstransforms) || false;
    $cssTransforms3d = (window.Modernizr && Modernizr.csstransforms3d) || false;

    // General Selectors
    $w    = $(window);
    $body = $('body');
    $html = $('html');

    // Track cart activity status
    isUpdating = false;

    // Check if we can use .load
    $nojQueryLoad = $html.hasClass('lt-ie9');
    if ($nojQueryLoad) {
      settings.useCartTemplate = false;
    }

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Enable the ajax cart
    if (!settings.disableAjaxCart) {
      // Handle each case add to cart method
      switch (settings.method) {
        case 'flip':
          flipSetup();
          break;

        case 'modal':
          modalSetup();
          break;

        case 'drawer':
          drawerSetup();
          break;
      }

      // Escape key closes cart
      $(document).keyup( function (evt) {
        if (evt.keyCode == 27) {
          switch (settings.method) {
            case 'flip':
            case 'drawer':
              hideDrawer();
              break;
            case 'modal':
              hideModal();
              break;
          }
        }
      });

      if ( $addToCart.length ) {
        // Take over the add to cart form submit
        formOverride();
      }
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  updateCountPrice = function (cart) {
    var displayItemCount = getDisplayItemCount(cart);

    if ($cartCountSelector) {
      $cartCountSelector.html(displayItemCount).removeClass('hidden-count');

      if (displayItemCount === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  getBundleId = function (cartItem) {
    var properties = cartItem && cartItem.properties ? cartItem.properties : {};
    return properties._ts_build_id || '';
  };

  isBundleParent = function (cartItem) {
    var properties = cartItem && cartItem.properties ? cartItem.properties : {};
    return properties._ts_bundle_role === 'parent' || properties._ts_role === 'base';
  };

  getDisplayItemCount = function (cart) {
    var count = 0,
        countedBundles = {};

    $.each(cart.items || [], function(index, cartItem) {
      var bundleId = getBundleId(cartItem);
      if (!bundleId) {
        count += cartItem.quantity || 0;
        return;
      }

      if (countedBundles[bundleId]) {
        return;
      }

      if (isBundleParent(cartItem)) {
        countedBundles[bundleId] = true;
        count += cartItem.quantity || 0;
      }
    });

    $.each(cart.items || [], function(index, cartItem) {
      var bundleId = getBundleId(cartItem);
      if (bundleId && !countedBundles[bundleId]) {
        countedBundles[bundleId] = true;
        count += cartItem.quantity || 0;
      }
    });

    return count;
  };

  buildDrawerRows = function (cart) {
    var rows = [],
        bundles = {};

    function productImage(cartItem) {
      return cartItem.image ? cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '') : '';
    }

    function productVariation(cartItem) {
      if (cartItem.variant_title && cartItem.variant_title !== 'Default Title') {
        return cartItem.variant_title;
      }
      return cartItem.title.replace(/^[^\-]*/, "").replace(/-/, "");
    }

    function productName(cartItem) {
      var properties = cartItem.properties || {};
      return properties._ts_bundle_title || cartItem.product_title || cartItem.title.replace(/(\-[^-]*)$/, "");
    }

    function bundleLabel(cartItem) {
      var properties = cartItem.properties || {};
      return properties._ts_bundle_label || productVariation(cartItem) || cartItem.product_title || cartItem.title;
    }

    function lineData(cartItem, line, overrides) {
      var quantity = cartItem.quantity || 1;
      return $.extend({
        id: cartItem.variant_id,
        line: line,
        url: cartItem.url,
        img: productImage(cartItem),
        name: productName(cartItem),
        variation: productVariation(cartItem),
        itemAdd: quantity + 1,
        itemMinus: quantity - 1,
        itemQty: quantity,
        price: Shopify.formatMoney(cartItem.line_price || (cartItem.price * quantity), settings.moneyFormat)
      }, overrides || {});
    }

    $.each(cart.items || [], function(index, cartItem) {
      var bundleId = getBundleId(cartItem),
          line = index + 1;

      if (!bundleId) {
        rows.push(lineData(cartItem, line));
        return;
      }

      if (!bundles[bundleId]) {
        bundles[bundleId] = {
          id: bundleId,
          items: [],
          parent: null,
          parentLine: line
        };
        rows.push(bundles[bundleId]);
      }

      bundles[bundleId].items.push({
        cartItem: cartItem,
        line: line
      });

      if (isBundleParent(cartItem)) {
        bundles[bundleId].parent = cartItem;
        bundles[bundleId].parentLine = line;
      }
    });

    return $.map(rows, function(row) {
      if (!row.items) {
        return row;
      }

      var parentEntry = row.items[0],
          parent = row.parent || parentEntry.cartItem,
          parentLine = row.parentLine || parentEntry.line,
          bundleTotal = 0,
          bundleKeys = [],
          addons = [];

      $.each(row.items, function(_index, entry) {
        var cartItem = entry.cartItem;
        bundleTotal += cartItem.line_price || (cartItem.price * cartItem.quantity);
        if (cartItem.key) {
          bundleKeys.push(cartItem.key);
        }
        if (!isBundleParent(cartItem)) {
          addons.push({
            label: bundleLabel(cartItem),
            price: Shopify.formatMoney(cartItem.line_price || (cartItem.price * cartItem.quantity), settings.moneyFormat)
          });
        }
      });

      return lineData(parent, parentLine, {
        isBundle: true,
        bundleKeys: bundleKeys.join('|'),
        addons: addons,
        price: Shopify.formatMoney(bundleTotal, settings.moneyFormat)
      });
    });
  };

  flipSetup = function () {
    // Build and append the drawer in the DOM
    drawerSetup();

    // Stop if there is no add to cart button
    if ( !$addToCart.length ) {
      return
    }

    // Wrap the add to cart button in a div
    $addToCart.addClass('flip-front').wrap('<div class="flip"></div>');

    // Write a (hidden) Checkout button, a loader, and the extra view cart button
    var checkoutBtn = $('<a href="/cart" class="flip-back" style="background-color: #C00; color: #fff;" id="flip-checkout">' + "Checkout securely" + '</a>').addClass($btnClass),
        flipLoader = $('<span class="ajaxifyCart-loader"></span>'),
        flipExtra = $('<div class="flip-extra">' + "or" + ' <a href="#" class="flip-cart">' + "View Cart" + ' (<span></span>)</a></div>');

    // Append checkout button and loader
    checkoutBtn.insertAfter($addToCart);
    flipLoader.insertAfter(checkoutBtn);

    // Setup new selectors
    $flipContainer = $('.flip');

    if (!$cssTransforms3d) {
      $flipContainer.addClass('no-transforms')
    }

    // Setup extra selectors once appended
    flipExtra.insertAfter($flipContainer);
    $flipCart = $('.flip-cart');

    $flipCart.on('click', function(e) {
      e.preventDefault();
      showDrawer(true);
    });

    // Reset the button if a user changes a variation
    $('input[type="checkbox"], input[type="radio"], select', $formContainer).on('click', function() {
      revertFlipButton();
    })
  };

  revertFlipButton = function () {
    $flipContainer.removeClass('is-flipped');
  };

  modalSetup = function () {
    // Create modal DOM elements with handlebars.js template
    var source   = $("#modalTemplate").html(),
        template = Handlebars.compile(source);

    // Append modal and overlay to body
    $body.append(template).append('<div id="ajaxifyCart-overlay"></div>');

    // Modal selectors
    $modalContainer = $('#ajaxifyModal');
    $modalOverlay   = $('#ajaxifyCart-overlay');
    $cartContainer  = $('#ajaxifyCart');

    // Close modal when clicking the overlay
    $modalOverlay.on('click', hideModal);

    // Create a close modal button
    $modalContainer.prepend('<button class="ajaxifyCart--close" title="' + "Close Cart" + '">' + "Close Cart" + '</button>');
    $closeCart = $('.ajaxifyCart--close');
    $closeCart.on('click', hideModal);

    // Add a class if CSS translate isn't available
    if (!$cssTransforms) {
      $modalContainer.addClass('no-transforms')
    }

    // Update modal position on screen changes
    $(window).on({
      orientationchange: function(e) {
        if ($modalContainer.hasClass('is-visible')) {
          sizeModal('resize');
        }
      }, resize: function(e) {
        // IE8 fires this when overflow on body is changed. Ignore IE8.
        if (!$nojQueryLoad && $modalContainer.hasClass('is-visible')) {
          sizeModal('resize');
        }
      }
    });

    // Toggle modal with cart button
    setToggleButtons();
  };

  showModal = function (toggle) {
    $body.addClass('ajaxify-modal--visible');
    // Build the cart if it isn't already there
    if ( !cartInit && toggle ) {
      Shopify.getCart(cartUpdateCallback);
    } else {
      sizeModal();
    }
  };

  sizeModal = function(isResizing) {
    if (!isResizing) {
      $modalContainer.css('opacity', 0);
    }

    // Position modal by negative margin
    $modalContainer.css({
      'margin-left': - ($modalContainer.outerWidth() / 2),
      'opacity': 1
    });

    $modalContainer.addClass('is-visible');

    scrollTop();

    toggleCallback({
      'is_visible': true
    });
  };

  hideModal = function (e) {
    $body.removeClass('ajaxify-modal--visible');
    if (e) {
      e.preventDefault();
    }

    if ($modalContainer) {
      $modalContainer.removeClass('is-visible');
      $body.removeClass('ajaxify-lock');
    }

    toggleCallback({
      'is_visible': false
    });
  };

  drawerSetup = function () {
    // Create drawer DOM elements with handlebars.js template
    var source   = $("#drawerTemplate").html(),
        template = Handlebars.compile(source),
        data = {
          wrapperClass: $wrapperClass
        };

    // Append drawer (defaults to body)
    $prependDrawerTo.prepend(template(data));

	    // Drawer selectors
	    $drawerContainer = $('#ajaxifyDrawer');
	    $cartContainer   = $('#ajaxifyCart');
	    $drawerCaret     = $('.ajaxifyDrawer-caret > span');
	    $drawerOverlay   = $('#ajaxifyCart-overlay');

	    $drawerOverlay.off('click').on('click', hideDrawer);
	    $body.off('click.ajaxifyDrawerClose').on('click.ajaxifyDrawerClose', '[data-ajaxify-close]', function(e) {
	      e.preventDefault();
	      hideDrawer();
	    });
	    $body.off('click.ajaxifyDrawerSearch').on('click.ajaxifyDrawerSearch', '[data-ajaxify-search-submit]', function(e) {
	      e.preventDefault();
	      var query = $(this).closest('.ajaxifyCart--drawer-search').find('[data-ajaxify-search-input]').val();
	      if (query && $.trim(query)) {
	        window.location.href = '/search?type=product&q=' + encodeURIComponent($.trim(query));
	      }
	    });
	    $body.off('keydown.ajaxifyDrawerSearch').on('keydown.ajaxifyDrawerSearch', '[data-ajaxify-search-input]', function(e) {
	      if (e.key === 'Enter' || e.keyCode === 13) {
	        e.preventDefault();
	        $(this).closest('.ajaxifyCart--drawer-search').find('[data-ajaxify-search-submit]').trigger('click');
	      }
	    });

    // Toggle drawer with cart button
    setToggleButtons();

    // Position caret and size drawer on resize if drawer is visible
    var timeout;
    $(window).resize(function() {
      clearTimeout(timeout);
      timeout = setTimeout(function(){
        if ($drawerContainer.hasClass('is-visible')) {
          positionCaret();
          sizeDrawer();
        }
      }, 500);
    });

    // Position the caret the first time
    positionCaret();

    // Position the caret
    function positionCaret() {
      if ($toggleCartButton.offset()) {
        // Get the position of the toggle button to align the carat with
        var togglePos = $toggleCartButton.offset(),
            toggleWidth = $toggleCartButton.outerWidth(),
            toggleMiddle = togglePos.left + toggleWidth/2;

        $drawerCaret.css('left', toggleMiddle + 'px');
      }
    }
  };

	  showDrawer = function (toggle) {
    // If we're toggling with the flip method, use a special callback
    if (settings.method == 'flip') {
      Shopify.getCart(flipCartUpdateCallback);
    }
    // opening the drawer for the first time
    else if ( !cartInit && toggle) {
      Shopify.getCart(cartUpdateCallback);
    }
    // simple toggle? just size it
    else if ( cartInit && toggle ) {
      sizeDrawer();
    }

	    // Show the drawer on the next frame so the closed transform can animate.
	    $drawerContainer.removeAttr('hidden');
	    $drawerOverlay.removeAttr('hidden');
	    if ($drawerContainer[0]) {
	      $drawerContainer[0].offsetWidth;
	    }
	    window.requestAnimationFrame(function() {
	      $body.addClass('ajaxify-drawer--visible ajaxify-lock');
	      $drawerContainer.attr('aria-hidden', 'false').addClass('is-visible');

	      toggleCallback({
	        'is_visible': true
	      });
	    });
	  };

	  hideDrawer = function (e) {
	    if (e) {
	      e.preventDefault();
	    }
	    $body.removeClass('ajaxify-drawer--visible ajaxify-lock');
	    $drawerContainer.removeAttr('style').attr('aria-hidden', 'true').removeClass('is-visible');
	    setTimeout(function() {
	      if (!$drawerContainer.hasClass('is-visible')) {
	        $drawerContainer.attr('hidden', 'hidden');
	        $drawerOverlay.attr('hidden', 'hidden');
	      }
	    }, 360);
	    toggleCallback({
	      'is_visible': false
	    });
	  };

	  sizeDrawer = function ($empty) {
	    if ($empty && !$drawerContainer.hasClass('is-visible')) {
	      $drawerContainer.removeAttr('style');
	      return;
	    }
	    $('.cart-row img').css('width', 'auto'); // fix Chrome image size bug
	    $drawerContainer.css('height', $(window).height() + 'px');
	  };

  loadCartImages = function () {
    // Size cart once all images are loaded
    var cartImages = $('img', $cartContainer),
        count = cartImages.length,
        index = 0;

    cartImages.on('load', function() {
      index++;

      if (index==count) {
        switch (settings.method) {
          case 'modal':
            sizeModal();
            break;
          case 'flip':
          case 'drawer':
            sizeDrawer();
            break;
        }
      }
    });
  };

  formOverride = function () {
    $addToCart.off('click.ajaxifyCart').on('click.ajaxifyCart', function(e) {
      var form = $(this).closest(settings.formSelector);
      if (!form.length) {
        form = $(this).closest('form[action^="/cart/add"]');
      }
      if (!form.length) {
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      form.trigger('submit.ajaxifyCart');
    });

    $formContainer.off('submit.ajaxifyCart').on('submit.ajaxifyCart', function(e) {
      e.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      Shopify.addItemFromForm(this, itemAddedCallback, itemErrorCallback);

      // Set the flip button to a loading state
      switch (settings.method) {
        case 'flip':
          $flipContainer.addClass('flip--is-loading');
          break;
      }
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    // Slight delay of flip to mimic a longer load
    switch (settings.method) {
      case 'flip':
        setTimeout(function () {
          $flipContainer.removeClass('flip--is-loading').addClass('is-flipped');
        }, 600);
        break;
    }
    Shopify.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    switch (settings.method) {
      case 'flip':
        $flipContainer.removeClass('flip--is-loading');
        break;
    }

    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    switch (settings.method) {
      case 'flip':
        $('.flip-cart span').html(cart.item_count);
        break;
      case 'modal':
        buildCart(cart);
        break;
      case 'drawer':
        buildCart(cart);
        if ( !$drawerContainer.hasClass('is-visible') ) {
          showDrawer();
        } else {
          scrollTop();
        }
        break;
    }
  };

  setToggleButtons = function () {
    // Reselect the element in case it just loaded
    $toggleCartButton  = $(settings.toggleCartButton);

    if ($toggleCartButton && $toggleCartButton.length) {
      $toggleCartButton.removeAttr('data-toggle aria-expanded').addClass('cart-toggle');
      $('#cart .dropdown-menu').attr('hidden', 'hidden').hide();
      // Turn it off by default, in case it's initialized twice
      $toggleCartButton.off('click');

      // Toggle the cart, based on the method
      $toggleCartButton.on('click', function(e) {
        e.preventDefault();

        switch (settings.method) {
          case 'modal':
            if ( $modalContainer.hasClass('is-visible') ) {
              hideModal();
            } else {
              showModal(true);
            }
            break;
          case 'drawer':
          case 'flip':
            if ( $drawerContainer.hasClass('is-visible') ) {
              hideDrawer();
            } else {
              showDrawer(true);
            }
            break;
        }

      });

    }
  };

  flipCartUpdateCallback = function (cart) {
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Empty cart if using default layout or not using the .load method to get /cart
    if (!settings.useCartTemplate || cart.item_count === 0) {
      $cartContainer.empty();
    }

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer.append('<form action="/cart" method="post" class="cart-form ajaxifyCart--drawer-form ajaxifyCart--drawer-form-empty" novalidate><div class="ajaxifyCart--drawer-header"><div><span>Cart</span><small>0 items</small></div><button type="button" class="ajaxifyCart--drawer-close" data-ajaxify-close aria-label="Close cart">&times;</button></div><div class="ajaxifyCart--drawer-tools"><div class="ajaxifyCart--drawer-search" role="search"><label class="sr-only" for="ajaxifyCart-search-empty">Search products</label><input id="ajaxifyCart-search-empty" type="search" placeholder="Search products" autocomplete="off" data-ajaxify-search-input><button type="button" data-ajaxify-search-submit aria-label="Search products"><span class="ion-ios-search-strong" aria-hidden="true"></span></button></div><div class="ajaxifyCart--drawer-links"><button type="button" data-ajaxify-close>Continue shopping</button><a href="/collections/all">Shop all products</a></div></div><div class="ajaxifyCart--products ajaxifyCart--empty"><span class="ajaxifyCart--empty-icon" aria-hidden="true">+</span><p class="ajaxifyCart--empty-kicker">Your next upgrade starts here</p><h2>' + "Your cart is currently empty." + '</h2><p>Search for a part or explore the full DH Styling catalogue.</p><a class="ajaxifyCart--empty-cta" href="/collections/all">Shop all products <span aria-hidden="true">&rarr;</span></a></div></form>');

      switch (settings.method) {
        case 'modal':
          sizeModal('resize');
          break;
        case 'flip':
        case 'drawer':
          sizeDrawer();

          if (!$drawerContainer.hasClass('is-visible') && cartInit) {
            sizeDrawer(true);
          }
          break;
      }
      return;
    }

    // Use the /cart template, or Handlebars.js layout based on theme settings
    if (settings.useCartTemplate) {
      cartTemplate(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        data = {};

    var source   = $("#cartTemplate").html(),
        template = Handlebars.compile(source);

    items = buildDrawerRows(cart);

    // Gather all cart data and add to DOM
	    data = {
	      items: items,
	      itemCount: cart.item_count,
	      itemLabel: cart.item_count === 1 ? 'item' : 'items',
	      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
	      note: cart.note || '',
	      btnClass: $btnClass
	    }
    $cartContainer.append(template(data));

    // With new elements we need to relink the adjust cart functions
    adjustCart();

    // Setup close modal button and size drawer
    switch (settings.method) {
      case 'modal':
        loadCartImages();
        break;
      case 'flip':
      case 'drawer':
        if (cart.item_count > 0) {
          loadCartImages();
        } else {
          sizeDrawer(true);
        }
        break;
      default:
        break;
    }

    // Mark the cart as built
    cartInit = true;
  };

  cartTemplate = function (cart) {
    $cartContainer.load('/cart form[action="/cart"]', function() {

      // With new elements we need to relink the adjust cart functions
      adjustCart();

      // Size drawer at this point
      switch (settings.method) {
        case 'modal':
          loadCartImages();
          break;
        case 'flip':
        case 'drawer':
          if (cart.item_count > 0) {
            loadCartImages();
          } else {
            sizeDrawer(true);
          }
          break;
        default:
          break;
      }

      // Mark the cart as built
      cartInit = true;
    });
  }

  adjustCart = function () {
    // This function runs on load, and when the cart is reprinted

    // Create ajax friendly quantity fields and remove links in the ajax cart
    if (settings.useCartTemplate) {
      createQtySelectors();
    }

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.cart-form', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Update quantify selectors
    var qtyAdjust = $('.ajaxifyCart--qty span');

    // Add or remove from the quantity
    qtyAdjust.off('click');
    qtyAdjust.on('click', function() {
	      var el = $(this),
	          line = el.data('line'),
	          bundleKeys = el.closest('.ajaxifyCart--product').data('bundle-keys'),
	          qtySelector = el.siblings('.ajaxifyCart--num'),
	          qty = parseInt( qtySelector.val() );

      qty = validateQty(qty);

      // Add or subtract from the current quantity
      if (el.hasClass('ajaxifyCart--add')) {
        qty = qty + 1;
      } else {
        qty = qty <= 0 ? 0 : qty - 1;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
	      if (bundleKeys) {
	        updateBundleQuantity(bundleKeys, qty);
	      } else if (line) {
	        updateQuantity(line, qty);
	      } else {
	        qtySelector.val(qty);
      }

    });

    // Update quantity based on input on change
    var qtyInput = $('.ajaxifyCart--num');
    qtyInput.off('change');
    qtyInput.on('change', function() {
	      var el = $(this),
	          line = el.data('line'),
	          bundleKeys = el.closest('.ajaxifyCart--product').data('bundle-keys'),
	          qty = el.val();

      // Make sure we have a valid integer
      if( (parseFloat(qty) == parseInt(qty)) && !isNaN(qty) ) {
        // We have a number!
      } else {
        // Not a number. Default to 1.
        el.val(1);
        return;
      }

      // If it has a data-line, update the cart
	      if (bundleKeys) {
	        updateBundleQuantity(bundleKeys, qty);
	      } else if (line) {
	        updateQuantity(line, qty);
	      }
	    });

    // Highlight the text when focused
    qtyInput.off('focus');
    qtyInput.on('focus', function() {
      var el = $(this);
      setTimeout(function() {
        el.select();
      }, 50);
    });

    // Completely remove product
    $('.ajaxifyCart--remove').on('click', function(e) {
	      var el = $(this),
	          line = el.data('line') || null,
	          bundleKeys = el.data('bundle-keys') || el.closest('.ajaxifyCart--product').data('bundle-keys'),
	          qty = 0;

	      // Without a data-line, let the default link action take over
	      if (!line && !bundleKeys) {
	        return;
	      }

	      e.preventDefault();
	      if (bundleKeys) {
	        updateBundleQuantity(bundleKeys, qty);
	      } else {
	        updateQuantity(line, qty);
	      }
	    });

	    function parseBundleKeys(keysString) {
	      if (!keysString) {
	        return [];
	      }
	      return String(keysString).split('|').filter(function(key) {
	        return key;
	      });
	    }

	    function updateBundleQuantity(keysString, qty) {
	      var keys = parseBundleKeys(keysString),
	          updates = {};

	      if (!keys.length) {
	        return;
	      }

	      qty = validateQty(parseInt(qty, 10));
	      isUpdating = true;

	      var row = $('.ajaxifyCart--product[data-bundle-keys="' + keysString + '"] .ajaxifyCart--row').addClass('ajaxifyCart--is-loading');
	      if ( qty === 0 ) {
	        row.addClass('is-removed');
	      }

	      $.each(keys, function(_index, key) {
	        updates[key] = qty;
	      });

	      setTimeout(function() {
	        $.ajax({
	          type: 'POST',
	          url: '/cart/update.js',
	          data: JSON.stringify({ updates: updates }),
	          contentType: 'application/json',
	          dataType: 'json',
	          success: adjustCartCallback,
	          error: function(XMLHttpRequest, textStatus) {
	            isUpdating = false;
	            Shopify.onError(XMLHttpRequest, textStatus);
	          }
	        });
	      }, 250);
	    }

	    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      if (!settings.useCartTemplate) {
        var row = $('.ajaxifyCart--row[data-line="' + line + '"]').addClass('ajaxifyCart--is-loading');
      } else {
        var row = $('.cart-row[data-line="' + line + '"]').addClass('ajaxifyCart--is-loading');
      }

      if ( qty === 0 ) {
        row.addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        Shopify.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    var noteArea = $('textarea[name="note"]');
    noteArea.off('change');
    noteArea.on('change', function() {
      var newNote = $(this).val();

      // Simply updating the cart note in case they don't click update/checkout
      Shopify.updateCartNote(newNote, function(cart) {});
    });
    if (typeof GoogleWalletButton === "function") GoogleWalletButton();
    if (typeof AmazonPaymentsPayButton === "function") AmazonPaymentsPayButton();
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Hide the modal or drawer if we're at 0 items
    if ( cart.item_count === 0 ) {
      // Handle each add to cart method
      switch (settings.method) {
        case 'modal':
          break;
        case 'flip':
        case 'drawer':
          hideDrawer();
          break;
      }
    }

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      Shopify.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var el = $(this),
            currentQty = parseInt(el.val());

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty + ' x';

        var source   = $("#ajaxifyQty").html(),
            template = Handlebars.compile(source),
            data = {
              line: el.attr('data-line'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        el.after(template(data)).remove();
      });
    }

    // If there is a regular link to remove an item, add attributes needed to ajaxify it
    if ($('a[href^="/cart/change"]', $cartContainer).length) {
      $('a[href^="/cart/change"]', $cartContainer).each(function() {
        var el = $(this).addClass('ajaxifyCart--remove');
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    // DH family forms retain their native quantity constraints and validation.
    var numInputs = $('input[type="number"]').filter(function() {
      return !$(this).closest('.dhf-form').length;
    });

    // Qty selector has a minimum of 1 on the product page
    // and 0 in the cart (determined on qty click)
    var qtyMin = 0;

    if (numInputs.length) {
      numInputs.each(function() {
        var el = $(this),
            currentQty = parseInt(el.val()),
            inputName = el.attr('name'),
            inputId = el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#jsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js--qty-adjuster').on('click', function() {
        var el = $(this),
            id = el.data('id'),
            qtySelector = el.siblings('.js--num'),
            qty = parseInt( qtySelector.val() );

        var qty = validateQty(qty);
        qtyMin = $body.hasClass('template-product') ? 1 : qtyMin;

        // Add or subtract from the current quantity
        if (el.hasClass('js--add')) {
          qty = qty + 1;
        } else {
          qty = qty <= qtyMin ? qtyMin : qty - 1;
        }

        // Update the input's number
        qtySelector.val(qty);
      });
    }
  };

  scrollTop = function () {
    if ($body.scrollTop() > 0 || $html.scrollTop() > 0) {
      $('html, body').animate({
        scrollTop: 0
      }, 250, 'swing');
    }
  };

  toggleCallback = function (data) {
    // Run the callback if it's a function
    if (typeof settings.onToggleCallback == 'function') {
      settings.onToggleCallback.call(this, data);
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
      return qty;
    } else {
      // Not a number. Default to 1.
      return 1;
    }
  };

  module = {
    init: init
  };

  return module;

}(ajaxifyShopify || {}, jQuery));
